import React, { useState } from 'react';
import { ItemCategory } from '../components';

const CategoriesList = () => {

    const [tab, setTab] = useState(1);

    const categories = [
        {
            id: "forSale",
            name: "For Sale",
            active: 1,
            data: [
                {
                    link: "#/",
                    img: '../assets/img/480x320/img11.jpg',
                    offer: '2471 offers',
                    name: 'Edinburgh',
                    price: 'Prices from £1,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img29.jpg',
                    offer: '4659 offers',
                    name: 'Oxford',
                    price: 'Prices from £3,820,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img28.jpg',
                    offer: '2471 offers',
                    name: 'Edinburgh',
                    price: 'Prices from £3,371,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img10.jpg',
                    offer: '5523 offers',
                    name: 'Newcastle',
                    price: 'Prices from £2,588,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img9.jpg',
                    offer: '939 offers',
                    name: 'Liverpool',
                    price: 'Prices from £1,318,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img8.jpg',
                    offer: '364 offers',
                    name: 'Bristol',
                    price: 'Prices from £1,457,000'
                }
            ]
        },
        {
            id: "forRent",
            active: 2,
            name: "For Rent",
            data: [
                {
                    link: "#/",
                    img: '../assets/img/480x320/img11.jpg',
                    offer: '2471 offers',
                    name: 'Edinburgh',
                    price: 'Prices from £1,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img10.jpg',
                    offer: '5523 offers',
                    name: 'Newcastle',
                    price: 'Prices from £2,588,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img9.jpg',
                    offer: '939 offers',
                    name: 'Liverpool',
                    price: 'Prices from £1,318,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img28.jpg',
                    offer: '2471 offers',
                    name: 'Edinburgh',
                    price: 'Prices from £3,371,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img8.jpg',
                    offer: '364 offers',
                    name: 'Bristol',
                    price: 'Prices from £1,457,000'
                },
                {
                    link: "#/",
                    img: '../assets/img/480x320/img29.jpg',
                    offer: '4659 offers',
                    name: 'Oxford',
                    price: 'Prices from £3,820,000'
                }
            ]
        }
    ];

    return (
        <div className="container content-space-2 content-space-lg-3">
            <div className="w-md-75 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
                <h2>Browse properties by city in the UK</h2>
                <p>Take a deep dive and browse original neighborhood photos, drone footage, resident reviews and local insights to see if the homes for sale are right for you.</p>
            </div>

            <div className="text-center">
                <ul className="nav nav-segment mb-7" id="featuresTab" role="tablist">
                    {
                        categories.map((category, idx) => {
                            return <li className="nav-item" role="presentation" key={category.id} onClick={() => setTab(category.active)}>
                                <a className={`nav-link ${category.active === tab ? 'active' : ''}`} href={`#${category.id}`} id={`${category.id}-tab`} data-bs-toggle="tab" data-bs-target={`#${category.id}`} role="tab" aria-controls={category.id} aria-selected="true">{category.name}</a>
                            </li>
                        })
                    }
                </ul>
            </div>

            <div className="tab-content" id="houseHeroTabContent">
                {
                    categories.map((category, idx) => {
                        return <div className={`tab-pane fade ${category.active === 1 ? 'show active' : ''}`} key={category.id} id={category.id} role="tabpanel" aria-labelledby={`${category.id}-tab`}>
                            <div className="row gx-3">
                                {
                                    category.data.map((item, idx) => {
                                        return <ItemCategory item={item} key={idx}/>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>

        </div>
    );
}

export default CategoriesList;

